import React, {Component } from 'react';
import {plainTranslate } from '../../common/translate';
import {connect } from 'react-redux';
import {Select, Switch } from 'antd';
import 'antd/lib/modal/style/index.css';
import {FormOutlined, DeleteOutlined } from '@ant-design/icons';
import SlideModal from '../../common/SlideModal';
import Yamde from 'yamde';

const {Option } = Select;

class SectionContents extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            availableFields: []
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleArrayChange = this.handleArrayChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleMultipleSelectChange = this.handleMultipleSelectChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleElementChange = this.handleElementChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
        this.addNewSubItem = this.addNewSubItem.bind(this);
    }

    componentDidMount() {
        this.update();
    }

    addNewSubItem() {
        let items = this.state.value && this.state.value.value ? this.state.value.value : [];
        let fields = this.state.availableFields[0].fields;
        let newItem = [];
        for (let i = 0; i < fields.length; i++) {
            newItem.push({});
            newItem[i]['id'] = fields[i].id;
            newItem[i]['value'] = '';

        }
        items.push(newItem);
        let elem = this.state.value;
        elem.value = items;
        this.setState({ value: elem });
    }

    chooseSection(type) {
        let availableFields = this.props.fields.filter((item) => item.id == type);

        return availableFields ? availableFields : null;
    }

    handleElementChange(value) {
        let section = this.state.value;
        section.id = value;
        let availableFields = this.chooseSection(value);
        this.setState({
            availableFields: availableFields,
            value: section,
        });
    }

    update() {
        let availableFields = this.chooseSection(this.props.item.id);
        this.setState({
            value: this.props.item ? this.props.item : [],
            availableFields: availableFields
        });
    }

    handleArrayChange(e, type, valKey, arrKey) {
        let value = this.state.value;
        value.value[valKey][arrKey]['value'] = e.target.value;

         this.setState({value: value });
    }

    handleChange(e) {
        let value = this.state.value;
        value.value = e.target.value;

        this.setState({value: value });
    }

    markdownChange = (val) => {
        let value = this.state.value;
        value.value = val;

        this.setState({value: value });
    }

    handleSelectChange(val) {
        let value = this.state.value;
        value.value = val;

        this.setState({value: value });
    }

    handleMultipleSelectChange(val) {
        let value = this.state.value;
        let array = [];
        var i;
        for (i = 0; i < val.length; i++) {
            let newItem = {};
            newItem['value'] = val[i];
            newItem['label'] = this.state.availableFields[0].options.filter(item => item.value == val[i])[0].label;
            array.push(newItem);
        }
        value.value = array;
        this.setState({value: value });
    }

    handleSwitchChange(checked) {
        let value = this.state.value;
        value.value = checked;

        this.setState({value: value });
    }

    handleDelete(type, ind = null, subType = null, subInd = null) {
        let value = this.state.value;
        if (subInd !== null) {
            value[type][ind][subType].splice(subInd, 1);
        } else if (ind !== null && subInd == null) {
            value[type].splice(ind, 1);
        }

        this.setState({value: value });
    }

    showModal() {
        this.setState({
            visible: true,
        });
    }

    handleOk() {
        this.props.change();
        this.setState({
            visible: false,
        });
    }

    handleCancel() {
        this.setState({
            visible: false,
        });
    };

    componentDidUpdate(prevProps) {
        if (prevProps.item != this.props.item) {
            this.setState({
                value: this.props.item
            })
        }
    }

    render() {
        return (
            <div>
                {this.state.value &&
                    <div className="row">
                        <div className="accordion col-md-12 m-bot15">
                            <div className="accordion-group">
                                <div className="accordion-heading area collapsible col-md-12 no-gutter">
                                    <div className="col-md-9 col-xs-6">
                                        <strong>{this.state.value.id}</strong>
                                    </div>
                                    <div className="col-md-3 col-xs-6">
                                        <span style={{marginRight: 10 }} onClick={this.showModal}><FormOutlined title={plainTranslate(this.props.locale, 'Edit menu item')} /> {plainTranslate(this.props.locale, 'Edit')}</span>
                                        <span onClick={() => this.props.remove(this.state.value)}><DeleteOutlined title={plainTranslate(this.props.locale, 'Remove menu item')} /> {plainTranslate(this.props.locale, 'Delete')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.visible &&
                            <SlideModal
                                title={plainTranslate(this.props.locale, 'Edit item')}
                                onClose={this.handleCancel}
                            >
                                <section className="newPanel">
                                    <div className="panel-body">
                                        <div className="row m-bot15 form-group" >
                                            <label className="text-left">{plainTranslate(this.props.locale, 'Type element')}</label>
                                            <Select value={this.state.value.id} style={{maxWidth: '100%', minWidth: "100%", marginBottom: '10px'}} onChange={(value) => this.handleElementChange(value)}>
                                                {this.props.fields && this.props.fields.length && this.props.fields.map((field, key) => {
                                                    return <Option key={key} value={field.id}>{field.id}</Option>
                                                })                    
                                                }
                                            </Select>
                                            {this.state.availableFields.length ? this.state.availableFields.map((item, key) => {
                                                return <><div className='col-md-12' key={key}>
                                                    {item.type !== 'array' && <label className="text-left">{plainTranslate(this.props.locale, item.id)}</label>}
                                                    {item.type == 'text' &&
                                                        <input type="text" className="form-control" onChange={(e) => this.handleChange(e)}
                                                            value={this.state.value.value ? this.state.value.value : null}
                                                        />
                                                    }
                                                    {item.type == 'markdown' &&
                                                         <Yamde value={this.state.value.value ? this.state.value.value : null} handler={this.markdownChange} theme="light" />
                                                    }
                                                    {item.type == 'switch' &&
                                                        <Switch style={{ marginLeft: '30px' }} checked={this.state.value.value ? this.state.value.value : null} onChange={this.handleSwitchChange} />
                                                    }
                                                    {item.type == 'multipleSelect' &&
                                                        <Select mode="multiple" value={this.state.value && this.state.value.value && this.state.value.value.length && this.state.value.value.map(({ value }) => value)} style={{ maxWidth: '100%', minWidth: "100%", marginBottom: '10px' }} onChange={this.handleMultipleSelectChange}>
                                                            {item.options && item.options.length && item.options.map((option, key) => {
                                                                return <Option key={key} value={option.value}>{option.label}</Option>
                                                            })
                                                            }
                                                        </Select>
                                                    }
                                                    {item.type == 'select' &&
                                                        <Select value={this.state.value.value ? this.state.value.value : null} style={{ maxWidth: '100%', minWidth: "100%", marginBottom: '10px' }} onChange={this.handleSelectChange}>
                                                            {item.options && item.options.length && item.options.map((option, key) => {
                                                                return <Option key={key} value={option.value}>{option.label}</Option>
                                                            })
                                                            }
                                                        </Select>
                                                    }
                                                    {item.type == 'array' && this.state.value && this.state.value.value && this.state.value.value.length && this.state.value.value.map((sval, n) => {
                                                        return (<><p>{n + 1}</p>
                                                            {sval.map((sub, ind) => {
                                                                return <div className='col-md-12' key={ind}>
                                                                    <label className="text-left">{plainTranslate(this.props.locale, sub.id)}</label>
                                                                    <input type="text" className="form-control" onChange={(e) => this.handleArrayChange(e, sub.id, n, ind)}
                                                                        value={sub.value}
                                                                    />
                                                                </div>
                                                            })
                                                            }
                                                        </>
                                                        )
                                                    })}
                                                    {item.type == 'array' &&
                                                        <a className="button-outline grey" onClick={this.addNewSubItem}>{plainTranslate(this.props.locale, 'Add new')}</a>
                                                    }
                                                </div>
                                                </>
                                            })
                                                : <p>No fields added for this element</p>
                                            }
                                            <div style={{float: 'right'}}>
                                                <a className="button-outline grey" onClick={this.handleCancel}>{plainTranslate(this.props.locale, 'Cancel')}</a>
                                                <a className="button-outline green" onClick={this.handleOk}>{plainTranslate(this.props.locale, 'Save')}</a>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </SlideModal>
                        }
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    settings: state.settings,
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SectionContents);
